import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cloud, Sun, CloudRain, CloudSnow, Wind, CloudLightning } from 'lucide-react';

const WeatherApp = () => {
  const [selectedWeather, setSelectedWeather] = useState(null);

  const weathers = [
    { id: 'sunny', icon: Sun, color: 'bg-yellow-400', name: 'Sunny' },
    { id: 'cloudy', icon: Cloud, color: 'bg-gray-400', name: 'Cloudy' },
    { id: 'rainy', icon: CloudRain, color: 'bg-blue-600', name: 'Rainy' },
    { id: 'snowy', icon: CloudSnow, color: 'bg-blue-200', name: 'Snowy' },
    { id: 'windy', icon: Wind, color: 'bg-teal-500', name: 'Windy' },
    { id: 'storm', icon: CloudLightning, color: 'bg-purple-600', name: 'Storm' },
  ];

  const getVideoBackground = (weather) => {
    // Note: Replace these placeholder paths with actual video URLs in your implementation
    switch (weather) {
      case 'sunny':
        return '/videos/sunny.mp4';
      case 'cloudy':
        return '/videos/cloudy.mp4';
      case 'rainy':
        return '/videos/rain.mp4';
      case 'snowy':
        return '/videos/snow.mp4';
      case 'windy':
        return '/videos/wind.mp4';
      case 'storm':
        return '/videos/storm.mp4';
      default:
        return '/videos/default.mp4';
    }
  };

  const VideoBackground = ({ weather }) => (
    <motion.div
      key={weather}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      className="absolute inset-0 z-0 bg-gray-900"
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
        src={getVideoBackground(weather)}
      />
      <div className="absolute inset-0 bg-black/30" /> {/* Overlay for better text contrast */}
    </motion.div>
  );

  

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-gray-900 text-white">
      <AnimatePresence>
        {selectedWeather && (
          <VideoBackground weather={selectedWeather} />
        )}
      </AnimatePresence>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen p-8">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-6xl font-bold mb-12 text-center"
        >
          {selectedWeather ? 
            weathers.find(w => w.id === selectedWeather)?.name : 
            "Select Weather"}
        </motion.h1>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-2xl">
          {weathers.map((weather) => {
            const Icon = weather.icon;
            return (
              <motion.button
                key={weather.id}
                onClick={() => setSelectedWeather(weather.id)}
                className={`
                  p-6 rounded-lg backdrop-blur-sm
                  ${selectedWeather === weather.id ? 
                    'bg-white/20 ring-2 ring-white' : 
                    'bg-white/10 hover:bg-white/15'}
                  transition-all duration-300 ease-out
                `}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="flex flex-col items-center gap-3">
                  <Icon size={32} />
                  <span className="font-medium">{weather.name}</span>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WeatherApp;